<template>
  <mute-radio
    v-bind="$attrs"
    v-model="value"
    :name="name"
  />
</template>

<script>
import { useField } from 'vee-validate';
import MuteRadio from '../mute-radio.vue';

export default {
  components: { MuteRadio },
  props: {
    name: { type: String, required: true },
  },

  setup(props) {
    const { value } = useField(props.name);

    return { value };
  },
};
</script>
